// 接口前缀
const common_api_auth = '/auth'
const common_api_project = '/project'
const common_api_expert = '/expert'
const common_api_member = '/member'

const apiurl = {}
// 获取短信验证码
apiurl.getCode = common_api_auth + '/verification/code/get'
// 个人详情
// apiurl.MyDetail = common_api_auth + '/user/getMyselfUserDetail'
// 修改个人详情
apiurl.updateUserInfo = common_api_auth + '/user/updateUserInfo'
// 查看个人详情
apiurl.getSelfUserDetail = common_api_auth + '/user/getSelfUserDetail'
// 注册账号
apiurl.register = common_api_auth + '/user/register'
// 登录账号
apiurl.login = common_api_auth + '/login'
// 注销账号
apiurl.logout = common_api_auth + '/user/logout'
// 企业账号注册 
apiurl.enterprise_register = common_api_member + '/enterprise/register'
// 上传企业图标
apiurl.upload_img = common_api_member + '/upload/img'
// 获取用户
apiurl.get_all = common_api_auth + '/user/get-all'
// 模糊搜索用户 name=
apiurl.getUserByName = common_api_auth + '/user/getUserByName'
apiurl.getShimoToken = common_api_auth + '/user/getShiMoSignature'

// 重置密码
apiurl.update_password = common_api_auth + '/user/updatePassword'
// 首页——待处理事项
apiurl.getPersonalHandled = common_api_auth + '/getPersonalHandled'
// 获取项目初始化
apiurl.projectInfo = common_api_project + '/get-project-info'
// 创建标准项目
apiurl.create = common_api_project + '/create'
// 创建其他项目
apiurl.createOther = common_api_project + '/createOther'
// 创建课程建设
apiurl.createCourse = common_api_project + '/createCourse'
// 删除项目
apiurl.deleteProject = common_api_project + '/deleteProject'
// 搜索项目
apiurl.get_project_info = common_api_project + '/get-project-info'
// 获取项目责任人下拉框
apiurl.get_project_owner  = common_api_project + '/getProjectOwner'
// 获取项目助理下拉框
apiurl.get_project_assistant  = common_api_project + '/getProjectAssistant'
// 项目详情
apiurl.get = common_api_project + '/get'
// 获取项目责任人
apiurl.getowner = common_api_project + '/get-project-owner'
// 查询标准与规范列表
apiurl.file = common_api_project + '/get/standard-file'
// 删除标准与规范
apiurl.delete_standard = common_api_project + '/delete-standard'
// 上传文件
apiurl.upload = common_api_project + '/file/upload'
// 图片
apiurl.img = common_api_project + '/file/img'
// 创建项目的上传图片
apiurl.upload_img = common_api_project + '/file/upload/img'
// 获取主页已发布标准
apiurl.getHaveReleasedProject = common_api_project + '/getHaveReleasedProject'
// 已发布标准
apiurl.getHaveReleasedByProjectId = common_api_project + '/getHaveReleasedByProjectId'
// 获取已发布的项目
apiurl.getReleaseProjectUser = common_api_project + '/getReleaseProjectUser'
// 获取已发布项目下得所有角色
apiurl.addReleaseProjectUser = common_api_project + '/addReleaseProjectUser'
// 批量删除
apiurl.deleteReleaseProjectUser = common_api_project + '/deleteReleaseProjectUser'
// 获取标准
apiurl.getHaveReleasedStandard = common_api_project + '/getHaveReleasedStandard'
// 获取未授权文件人员信息
apiurl.getNotPermissionProjectUser = common_api_project + '/getNotPermissionProjectUser'
// 获取项目阶段
apiurl.getProjectPhase = common_api_project + '/getProjectPhase'
// 获取项目任务
apiurl.getProjectTaskPlan = common_api_project + '/getProjectTaskPlan'
// 获取项目责任人
apiurl.getTaskNameOwner = common_api_project + '/getTaskNameOwner'


// 下载文件
apiurl.downloadFile = common_api_project + '/file/download'
apiurl.fileAdd = common_api_project + '/standard-file/add'
apiurl.fileUpdate = common_api_project + '/standard-file/update'
// 新建标准文件
apiurl.addStandardFileAndUpload = common_api_project + '/addStandardFileAndUpload'
// 修改标准文件
apiurl.updateStandardFileAndUpload = common_api_project + '/updateStandardFileAndUpload'
// 查看历史版本
apiurl.getBeforeVersionFile = common_api_project + '/getBeforeVersionFile'

apiurl.update_project = common_api_project + '/update-project'

// 获取文件目录分类 
apiurl.get_standardCatalog = common_api_project + '/get/standardCatalog'

//  获取任务计划表
apiurl.get_task_plan = common_api_project + '/get-task-plan'
// 获取任务名称
apiurl.getTaskName = common_api_project + '/getTaskName'


// 添加任务
apiurl.createProjectTaskPlan = common_api_project + '/createProjectTaskPlan'
// 删除任务
apiurl.deleteProjectTaskPlan = common_api_project + '/deleteProjectTaskPlan'
// 修改任务
apiurl.updateProjectTaskPlan = common_api_project + '/updateProjectTaskPlan'
// 新增阶段
apiurl.createProjectPhase = common_api_project + '/createProjectPhase'
// 编辑阶段
apiurl.updateProjectPhase = common_api_project + '/updateProjectPhase'
// 删除阶段
apiurl.deleteProjectPhase = common_api_project + '/deleteProjectPhase'

// 删除文件
apiurl.file_delete = common_api_project + '/file/delete'



// 删除任务目录
apiurl.delete_task_plan_catalog = common_api_project + '/delete_task_plan_catalog'
// 修改任务目录
apiurl.update_task_plan_catalog = common_api_project + '/update-task-plan-catalog'

// 添加文件
apiurl.add_task_plan = common_api_project + '/add-task-plan'
// 删除文件
apiurl.delete_task_plan = common_api_project + '/delete-task-plan'
// 修改文件
apiurl.update_task_plan = common_api_project + '/updateTaskPlan'
// 删除项目阶段下的任务文件
apiurl.deleteProjectTaskPlanFile = common_api_project + '/deleteProjectTaskPlanFile'

// 获取成员
apiurl.getProjectUser = common_api_project + '/get-project-user'
// 获取项目组
apiurl.getProjectGroup = common_api_project + '/getProjectGroup'
// 新增项目组
apiurl.createProjectGroup = common_api_project + '/createProjectGroup'
// 分配项目组
apiurl.update_project_user = common_api_project + '/update-project-user'
// 修改项目组
apiurl.updateProjectGroup = common_api_project + '/updateProjectGroup'
// 删除项目组
apiurl.deleteProjectGroup = common_api_project + '/deleteProjectGroup'
// 获取项目成员过滤后的用户
apiurl.getUserNotInProject = common_api_project + '/getUserNotInProject'
// 获取项目组的成员
apiurl.getProjectUserNotInGroup = common_api_project + '/getProjectUserNotInGroup'
// 添加项目成员
apiurl.add_project_user = common_api_project + '/add-project-user'
// 删除成员
apiurl.delete_project_user = common_api_project + '/delete-project-user'

apiurl.file_edit = common_api_project + '/file/edit'
apiurl.file_edit2 = common_api_project + '/edit'

// 添加授权
apiurl.addPermission = common_api_project + '/addPermission'
// 获取授权
apiurl.getPermission = common_api_project + '/getPermission'
// 修改权限
apiurl.updatePermission = common_api_project + '/updatePermission'
// 删除权限
apiurl.deletePermission = common_api_project + '/deletePermission'
// 获取权限文件
apiurl.getNotPermissionStandardFile = common_api_project + '/getNotPermissionStandardFile'

// 导出模板 + 导出
apiurl.exportExcel = common_api_project + '/exportExcel'

// 导入文件
apiurl.importExcel = common_api_project + '/importExcel'
// 状态修改
apiurl.updateStandardFileStatus = common_api_project + '/updateStandardFileStatus'
// 获取项目评审
apiurl.getProjectReview = common_api_project + '/getProjectReview'
// 获取标准部分 + 章节 的下拉框
apiurl.getProjectReviewPullDown = common_api_project + '/getProjectReviewPullDown'
// 新增标准
apiurl.createProjectReview = common_api_project + '/createProjectReview'
// 删除标准
apiurl.deleteProjectReview = common_api_project + '/deleteProjectReview'
// 修改标准
apiurl.updateProjectReview = common_api_project + '/updateProjectReview'
// 处理人
apiurl.opinionConfirmation = common_api_project + '/opinionConfirmation'
// 下载模板
apiurl.exportProjectReviewExcel = common_api_project + '/exportProjectReviewExcel'
// 导入模板
apiurl.importProjectReviewExcel = common_api_project + '/importProjectReviewExcel'
// 下载项目成员导入模板
apiurl.exportProjectUser = common_api_project + '/exportProjectUser'
// 导入项目成员数据
apiurl.importProjectUser = common_api_project + '/importProjectUser'
// 已发布标准导入项目成员数据
apiurl.importReleaseProjectUser = common_api_project + '/importReleaseProjectUser'

// 判断用户总体权限
apiurl.validationOwner = common_api_project + '/validationOwner'

// 用户管理 获取所有用户信息
apiurl.getUserDetail = common_api_auth + '/user/getUserDetail'
apiurl.queryUserDetail = common_api_auth + '/user/queryUserDetail'

// 获取所有角色
apiurl.role_get = common_api_auth + '/role/getAll'
// 添加角色
apiurl.role_add = common_api_auth + '/user/addRole'
// 添加用户
apiurl.user_addUser = common_api_auth + '/user/addUser'


// 查询公告
apiurl.getAnnouncement = common_api_auth + '/getAnnouncement'
// 获取下拉框主题名称
apiurl.getAnnouncementName = common_api_auth + '/getAnnouncementName'
// 创建公告
apiurl.createAnnouncement = common_api_auth + '/createAnnouncement'
// 修改公告
apiurl.updateAnnouncement = common_api_auth + '/updateAnnouncement'
// 删除公告
apiurl.deleteAnnouncement = common_api_auth + '/deleteAnnouncement'
// 共享资料库
apiurl.getSharedDatabase = common_api_auth + '/getSharedDatabase'
// 下载资料库
apiurl.download = common_api_auth + '/download'
// 获取菜单
apiurl.getSystemMenu = common_api_auth + '/getSystemMenu'

// 获取专家信息
apiurl.getExpertInfo = common_api_expert + '/getExpertInfo'
// 添加专家信息
apiurl.addExpertInfo = common_api_expert + '/addExpertInfo'
// 修改专家信息
apiurl.updateExpertInfo = common_api_expert + '/updateExpertInfo'
// 删除专家信息
apiurl.deleteExportInfo = common_api_expert + '/deleteExportInfo'
// 下载模板
apiurl.exportExcel_exportInfo = common_api_expert + '/exportExcel/exportInfo'
// 批量导入
apiurl.importExcel_exportInfo = common_api_expert + '/importExcel/exportInfo'

// 获取专家文档信息 
apiurl.document_getExpertDocument = common_api_expert + '/document/getExpertDocument'
// 创建文档信息
apiurl.document_createExpertDoc = common_api_expert + '/document/createExpertDoc'
// 修改文档信息
apiurl.document_updateExpertDoc = common_api_expert + '/document/updateExpertDoc'
// 删除
apiurl.document_deleteExpertDocumentById = common_api_expert + '/document/deleteExpertDocumentById'
// 上传文件
apiurl.uploadDoc = common_api_expert + '/document/upload'
// 上传照片
apiurl.uploadImg = common_api_expert + '/document/img'

// 获取专家模板
apiurl.getFileInfo = common_api_expert + '/document/getFileInfo'
// 下载模板
apiurl.Docdownload = common_api_expert + '/document/download'
// 查看页面
apiurl.doc_edit = common_api_expert + '/document/edit'
// 获取专家编号 
apiurl.doc_getExpertNumber = common_api_expert + '/document/getExpertNumber'
// 获取专家数量
apiurl.statisticalExpertQuantity = common_api_expert + '/statisticalExpertQuantity'
// 上传简历
apiurl.uploadCurriculumVitae = common_api_expert + '/uploadCurriculumVitae'
// 上传图片
apiurl.uploadImage = common_api_expert + '/uploadImage'
// 上传照片
apiurl.getExpertImg = common_api_expert + '/img'
// 获取顾问资源池
apiurl.getJoinGwExpert = common_api_expert + '/getJoinGwExpert'
// 上传顾问文件
apiurl.uploadGW = common_api_expert + '/document/uploadGW'
// 获取专家参与标准信息文件
apiurl.getProjectList = common_api_project + '/getProjectList'

/**
 * 
 * 会员模块
 * 
 * */ 
// 查询企业信息 
apiurl.enterprise_getMemberEnterprise = common_api_member + '/enterprise/getMemberEnterprise'
// 上传图片
apiurl.enterprise_upload_img = common_api_member + '/file/upload/img'
// 获取技术领域数据
apiurl.enterprise_getTechnosphere = common_api_member + '/getTechnosphere'
// 提交入会申请表
apiurl.enterprise_initiationApplyFor = common_api_member + '/initiationApplyFor'
// 查询提交材料文件
apiurl.file_queryFile = common_api_member + '/file/queryFile'
// 删除材料
apiurl.file_deleteEnterpriseFile = common_api_member + '/file/deleteEnterpriseFile'
// 添加材料
apiurl.file_upload = common_api_member + '/file/upload'


// 查看模板
apiurl.file_getEnterpriseTemplate = common_api_member + '/file/getEnterpriseTemplate'
// 打开onlyoffice
apiurl.file_vip_edit = common_api_member + '/file/edit'
// 下载
apiurl.file_download = common_api_member + '/file/download'
// 提交材料
apiurl.submitMemberApprovalProcess = common_api_member + '/submitMemberApprovalProcess'
// 审批流程
apiurl.addMemberApplicationExamine = common_api_member + '/addMemberApplicationExamine'
// 批量上传
apiurl.enterprise_upload = common_api_member + '/upload'
// 查询文件流程接口
apiurl.getMemberApprovalProcess = common_api_member + '/getMemberApprovalProcess'
// （会员部审批）修改审批
apiurl.updateMemberApprovalProcess = common_api_member + '/updateMemberApprovalProcess'
// 模板下载
apiurl.getEnterpriseTemplate = common_api_member + '/file/getEnterpriseTemplate'
/**
* 
*  技术领域
* 
* */ 
apiurl.getTechnosphere = common_api_member + '/getTechnosphere'
// 获取技术领域表
apiurl.getEnterpriseTechnosphere = common_api_member + '/getEnterpriseTechnosphere'
// 新增技术组
apiurl.addTechnosphere = common_api_member + '/addTechnosphere'
// 修改技术组
apiurl.updateTechnosphere = common_api_member + '/updateTechnosphere'
// 删除技术组
apiurl.deleteTechnosphere = common_api_member + '/deleteTechnosphere'

/**
 * 
 * 项目计划
 *
* */ 
// 获取项目计划
apiurl.getPhaseTemplate = common_api_project + '/getPhaseTemplate'
// 新增项目计划
apiurl.addPhaseTemplate = common_api_project + '/addPhaseTemplate'
// 删除项目计划
apiurl.deletePhaseTemplate = common_api_project + '/deletePhaseTemplate'
// 修改项目计划
apiurl.updatePhaseTemplate = common_api_project + '/updatePhaseTemplate'
// 获取项目计划列表
apiurl.getTaskPlanTemplate = common_api_project + '/getTaskPlanTemplate'
// 添加项目计划列表
apiurl.addTaskPlanTemplate = common_api_project + '/addTaskPlanTemplate'
// 编辑项目计划列表
apiurl.updateTaskPlanTemplate = common_api_project + '/updateTaskPlanTemplate'
// 删除项目计划列表
apiurl.deleteTaskPlanTemplate = common_api_project + '/deleteTaskPlanTemplate'
// 获取项目状态阶段
apiurl.getAllProjectPhase = common_api_project + '/getAllProjectPhase'

/**
 * 
 * 文件管理
 *
* */ 
// 获取文件管理tab列表
apiurl.getFileMenu = common_api_auth + '/common/getFileMenu'
// 获取具体文件列表o
apiurl.getAuthProjectFolder = common_api_auth + '/common/getFolderAndFile'

// 上传文件
apiurl.createFileUpload = common_api_auth + '/common/createFile/upload'
// 创建文件夹
apiurl.createFolder = common_api_auth + '/common/createFolder'
// 重命名文件夹
apiurl.renameFolder = common_api_auth + '/common/renameFolder'
// 删除文件夹
apiurl.deleteFolder = common_api_auth + '/common/deleteFolder'
// 删除文件
apiurl.deleteFile = common_api_auth + '/common/deleteFile'
// 文件重命名
apiurl.renameFile = common_api_auth + '/common/renameFile'
// 添加文件夹权限
apiurl.folderAuth = common_api_auth + '/common/folderAuth' 
// 获取文件夹权限
apiurl.getFolderAuth = common_api_auth + '/common/getFolderAuth'  
// 添加文件权限
apiurl.fileAuth = common_api_auth + '/common/fileAuth' 
// 获取文件权限
apiurl.getfileAuth = common_api_auth + '/common/getFileAuth'
// 删除文件夹权限
apiurl.deleteFolderAuth = common_api_auth + '/common/deleteFolderAuth'  
// 删除文件权限
apiurl.deleteFileAuth = common_api_auth + '/common/deleteFileAuth' 
// 获取没有被当层文件夹授权的项目成员
apiurl.getAllUserNotAuthFolde = common_api_auth + '/common/getAllUserNotAuthFolder'
// 获取没有被当文件授权的项目成员
apiurl.getUserNotAuthFile = common_api_auth + '/common/getUserNotAuthFile'
// 获取当前成员文件夹
apiurl.verifyFolderLoginPermissions = common_api_auth + '/common/verifyFolderLoginPermissions'
// 获取当前成员文件
apiurl.verifyFileLoginPermissions = common_api_auth + '/common/verifyFileLoginPermissions'
// 打开onlyoffice 类型
apiurl.file_common_edit = common_api_auth + '/common/edit'
// 获取图片内容
apiurl.common_img = common_api_auth + '/common/img'
/**
 * 
 * 标准管理
 *
* */ 
// 获取项目文件夹的
apiurl.getProjectIndoFolder = common_api_project + '/get-project-info/folder'
// 获取标准文件的文件信息
apiurl.getStandardFolderFile = common_api_project + '/getStandardFolderFile'
// 获取任务阶段文件夹
apiurl.getProjectPhaseFolder = common_api_project + '/getProjectPhaseFolder'
// 获取阶段下层任务计划/项目id/阶段id
apiurl.getProjectTaskPlanFolder = common_api_project + '/getProjectTaskPlanFolder'
// 获取任务计划下层文件/项目id/任务名称id
apiurl.getProjectTaskPlanFile = common_api_project + '/getProjectTaskPlanFile'
// 创建文件夹
apiurl.projectcreateFolder = common_api_project + '/createFolder'
// 上传文件
apiurl.projectcreateFileUpload = common_api_project + '/createFile/upload'
// 获取没有被当层文件夹授权的项目成员
apiurl.getProjectUserNotAuthFolder = common_api_project + '/getProjectUserNotAuthFolder'
// 获取没有被当文件授权的项目成员
apiurl.getProjectUserNotAuthFile = common_api_project + '/getProjectUserNotAuthFile'
// 获取具体文件列表other
apiurl.getProjectFolder = common_api_project + '/getFolderAndFile'
/**
 * 
 * 系统管理
 *
* */ 
// 获取所有菜单列表
apiurl.getAllSystemMenu = common_api_auth + '/getAllSystemMenu'
// 添加菜单
apiurl.addSystemMenu = common_api_auth + '/addSystemMenu'
// 删除菜单
apiurl.deleteSystemMenu = common_api_auth + '/deleteSystemMenu'
// 修改菜单
apiurl.updateSystemMenu = common_api_auth + '/updateSystemMenu'
// 获取所有租户
apiurl.getTenant = common_api_auth + '/user/getTenant'

// 创建角色
apiurl.caeateRole = common_api_auth + '/role/create'
// 更新角色
apiurl.updateRole = common_api_auth + '/role/update'
// 删除角色
apiurl.deleteteRole = common_api_auth + '/role/delete'
// 获取租户列表
apiurl.getEnterprise = common_api_auth + '/getEnterprise'
// 创建租户
apiurl.createEnterprise = common_api_auth + '/createEnterprise'
// 更新租户
apiurl.updateEnterprise = common_api_auth + '/updateEnterprise'

// 操作日志
apiurl.getSysOperLog = common_api_auth + '/getSysOperLog'
// 登录日志
apiurl.getSysLoginInfo = common_api_auth + '/getSysLoginInfo'
/**
 * 基础设置
 */
// 创建模板
apiurl.createClassify = common_api_project + '/createClassify'
// 更新模板
apiurl.updateClassify = common_api_project + '/updateClassify'
// 删除模板
apiurl.deleteClassify = common_api_project + '/deleteClassify'
// 获取模板列表
apiurl.getClassify = common_api_project + '/getClassify'
// 获取模板树
apiurl.getAllClassifyPhaseTaskPlan = common_api_project + '/getAllClassifyPhaseTaskPlan'

// 批注导出
apiurl.exportComment = common_api_project + '/file/exportComment'

/**
 * 项目组权限
 */
// 添加组权限
apiurl.batchAddGroupPermission = common_api_project + '/batchAddGroupPermission'
//获取组权限
apiurl.getGroupPermission = common_api_project + '/getGroupPermission'
//获取未授权组列表
apiurl.getNoGroupPermission = common_api_project + '/getNoGroupPermission'
// 编辑授权组列表
apiurl.updateGroupPermission = common_api_project + '/updateGroupPermission'
// 删除授权组列表
apiurl.deleteGroupPermission = common_api_project + '/deleteGroupPermission'

/**
 * 项目组权限-项目文件
 */
// 获取文件未授权的组
apiurl.getProjectGroupNotAuthFile = common_api_project + '/getProjectGroupNotAuthFile'
// 获取文件夹未授权的组
apiurl.getProjectGroupNotAuthFolder = common_api_project + '/getProjectGroupNotAuthFolder'
// 文件夹授权
apiurl.groupFolderAuth = common_api_project + '/common/groupFolderAuth'
// 文件授权组
apiurl.groupFileAuth = common_api_project + '/common/groupFileAuth'
// 已授权文件夹组
apiurl.getGroupFolderAuth = common_api_project + '/common/getGroupFolderAuth'
// 已授权文件组
apiurl.getGroupFileAuth = common_api_project + '/common/getGroupFileAuth'
//删除文件夹组权限
apiurl.deleteGroupFolderAuth = common_api_project + '/common/deleteGroupFolderAuth'
//删除文件组权限
apiurl.deleteGroupFileAuth = common_api_project + '/common/deleteGroupFileAuth'
// 获取某个项目组未授权的文件
apiurl.getNoGroupPermissionFile = common_api_project + '/getNoGroupPermissionFile'

// 过程跟踪下排序
apiurl.projectUpdateSort = common_api_project + '/projectUpdateSort'

// 下载文件-项目文件
apiurl.projectFileDownload = common_api_project + '/us/download'
// 下载文件-共享文件
apiurl.gxFileDownload = common_api_auth + '/common/us/download'

// 创建话题
apiurl.createCommentTopic = common_api_project + '/createCommentTopic'
// 创建评论
apiurl.createCommentContent = common_api_project + '/createCommentContent'
// 获取话题列表 projectId
apiurl.getCommentTopicByProjectId = common_api_project + '/getCommentTopicByProjectId'
// 获取评论列表 topicId&pid
apiurl.getCommentContentByPid = common_api_project + '/getCommentContentByPid'
// 创建评论内容的图片
apiurl.CommentTopicUploadImg = common_api_project + '/file/upload/img'
// 删除话题
apiurl.deleteCommentTopic = common_api_project + '/deleteCommentTopic'
// 删除评论
apiurl.deleteCommentContent = common_api_project + '/deleteCommentContent'



// 会员模块
// 创建会员信息
apiurl.createVipCompany = common_api_member + '/createVipCompany'
// 查询会员信息列表
apiurl.getVipCompany = common_api_member + '/getVipCompany'
// 更新会员信息 id
apiurl.updateVipCompany = common_api_member + '/updateVipCompany'
// 创建会员文件信息
apiurl.createVipFile = common_api_member + '/createVipFile'
// 删除会员文件信息
apiurl.deleteVipCompany = common_api_member + '/deleteVipCompany'
// 获取会员文件信息 vipId
apiurl.getVipFile = common_api_member + '/getVipFile'
// 更新会员文件信息 id
apiurl.updateVipFile = common_api_member + '/updateVipFile'
// 查看会员文件图片
apiurl.vipImg = common_api_member + '/vipImg'
// 下载会员文件
apiurl.vipFiledownload = common_api_member + '/file/download'
// 下载会员信息模板
apiurl.vipexportExcel = common_api_member + '/exportExcel/vipInfo'
// 导入会员信息模板
apiurl.vipimportExcel = common_api_member + '/importExcel/vipInfo'
// 创建会员财务信息
apiurl.createVipPay = common_api_member + '/createVipPay'
// 修改会员财务信息
apiurl.updateVipPay = common_api_member + '/updateVipPay'
// 获取会员财务信息
apiurl.getVipPay = common_api_member + '/getVipPay'
// 获取会员人员信息
apiurl.getVipMember = common_api_member + '/getVipMember'
// 添加会员人员信息
apiurl.addVipMember = common_api_member + '/addVipMember'
// 删除会员人员信息
apiurl.deleteVipMember = common_api_member + '/deleteVipMember'
// 动态导出会员基础信息
apiurl.exportCustomizeHeader = common_api_member + '/exportCustomizeHeader'
// 创建会员活动
apiurl.createVipActivity = common_api_member + '/createVipActivity'
// 更新会员活动
apiurl.updateVipActivity = common_api_member + '/updateVipActivity'
// 删除会员活动
apiurl.deleteVipActivity = common_api_member + '/deleteVipActivity/'
// 获取会员活动列表
apiurl.getVipActivity = common_api_member + '/getVipActivity'
// 获取会员活动会员列表
apiurl.getVipActivityCompany = common_api_member + '/getVipActivityCompany'
// 删除会员活动列表成员
apiurl.deleteVipActivityCompany = common_api_member + '/deleteVipActivityCompany'
// 更新会员活动列表成员
apiurl.updateVipActivityCompany = common_api_member + '/updateVipActivityCompany'
// 添加会员活动列表成员
apiurl.createVipActivityCompany = common_api_member + '/createVipActivityCompany'
// 获取会员活动列表
apiurl.getVipActivityByVipId = common_api_member + '/getVipActivityByVipId'
// 导入第三方活动信息表
apiurl.importExcelExportInfo = common_api_member + '/importExcel/exportInfo/'
// 修改第三方活动信息
apiurl.updateActivityCompany = common_api_member + '/updateActivityCompany'
// 获取第三方活动信息
apiurl.getActivityCompany = common_api_member + '/getActivityCompany'
// 创建年度缴费单
apiurl.createVipPayList = common_api_member + '/createVipPayList'
// 新会员注册
apiurl.externalApplication = common_api_member + '/externalApplication'
// 查看当前会员信息
apiurl.getMyselfVipCompany = common_api_member + '/getMyselfVipCompany'

// 大文件切片上传
apiurl.uploadFile = common_api_project + '/uploadFile/'
// 切片合并
apiurl.checkFile = common_api_project + '/checkFile/'
// 校验文件是否重名
apiurl.checkFileName = common_api_project + '/checkFileName/'


// 风格设置查询
apiurl.queryThemeCustom = common_api_auth + '/themeCustom/queryThemeCustom'
// 风格设置更新
apiurl.handleThemeCustom = common_api_auth + '/themeCustom/handleThemeCustom'
// 风格设置图片上传
apiurl.uploadImageCustom = common_api_auth + '/themeCustom/upload/image'


// 规范查询
apiurl.getSelfCheck = common_api_project + '/getSelfCheck'
// 规范新增
apiurl.createSelfCheck = common_api_project + '/createSelfCheck'
// 规范修改
apiurl.updateSelfCheck = common_api_project + '/updateSelfCheck'
// 规范删除
apiurl.deleteSelfCheck = common_api_project + '/deleteSelfCheck/'
// 新增自检人
apiurl.createSelfCheckerPerson = common_api_project + '/createSelfCheckerPerson'
// 我的自检查询
apiurl.getMySelfChecker = common_api_project + '/getMySelfChecker'
// 项目成员自检查询
apiurl.getSelfCheckerPerson = common_api_project + '/getSelfCheckerPerson'
// 自检明细查询
apiurl.getSelfCheckDetail = common_api_project + '/getSelfCheckDetail'
// 提交自检明细
apiurl.updateSelfCheckDetail = common_api_project + '/updateSelfCheckDetail'
// 自检导出
apiurl.exportSelfCheckExcel = common_api_project + '/exportExcel/exportInfo'
// 删除自检人
apiurl.deleteSelfCheckerPerson = common_api_project + '/deleteSelfCheckerPerson'

// 术语库管理
apiurl.getTerm = common_api_project + '/getTerm'
apiurl.getTermByText = common_api_project + '/getTermByText'
apiurl.getTermCategory = common_api_project + '/termCategory'
apiurl.createTerm = common_api_project + '/createTerm'
apiurl.updateTerm = common_api_project + '/updateTerm'
apiurl.deleteTerm = common_api_project + '/deleteTerm/'
apiurl.batchDeleteTerm = common_api_project + '/batch-delete'
apiurl.batchUpdateTermStatus = common_api_project + '/updateTerm'

apiurl.delete_rpoject_user = common_api_project + '/delete-project-user'

export default apiurl